import {ChangeDetectionStrategy, Component} from "@angular/core";
import {CommonModule} from "@angular/common";
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-hotel-tours-filters-skeleton',
  templateUrl: environment.mobile ? './filters-skeleton.component.mobile.html' : './filters-skeleton.component.html',
  styleUrls: environment.mobile ? ['./filters-skeleton.component.mobile.scss'] : ['./filters-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HotelToursFiltersSkeletonComponent {
  constructor() {}
}
